import { createSlice } from "@reduxjs/toolkit";
import {getWebsiteSettings} from "@features/website-settings/action";
import {websiteSettingsI} from "@features/website-settings/types";

const initialState: websiteSettingsI = {
  isLoading: false,
  websiteSettings: { loginWithPassword: false, BYODAvailable: true, reservePCAvailable: true, reservePlaceAvailable: true },
  error: null,
};

export const websiteSettingsSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    saveUser: (state, action) => action.payload,
  },
  extraReducers: (builder) => {
    builder.addCase(getWebsiteSettings.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(getWebsiteSettings.fulfilled, (state, action) => {
      state.isLoading = false;
      state.websiteSettings = action.payload;
    });
    builder.addCase(getWebsiteSettings.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
  },
});

export default websiteSettingsSlice.reducer;
